// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"zi-z","centerLink":"Ai-z","productSection":"Bi-z","item":"Ci-z","ctaButton":"Di-z"};